import { InfoBanner } from "src/components/InfoBanner";
import { englishifyList } from "src/language";
import { findMatrixByDuplicateTargetEmployeeId } from "../../MultipleMeritMatrices/utils";
import { useGuidanceAndBudget } from "../useGuidanceAndBudget";

type Props = { featureType: "bonus" | "merit" };

export function ConflictBanner({ featureType }: Props): JSX.Element | null {
  const {
    matrices: { selectedMatrix, meritMatrices },
  } = useGuidanceAndBudget(featureType);

  if (selectedMatrix === null) return null;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const conflicts = selectedMatrix.eligibilityValidations?.duplicates;

  if (conflicts == null) return null;

  const conflictingMatrices = new Set(
    conflicts
      .flatMap((employeeId) =>
        findMatrixByDuplicateTargetEmployeeId(meritMatrices, employeeId)
      )
      .map((m) => m.name)
  );

  if (conflicts.length === 0) return null;

  return (
    <InfoBanner fullWidth level="error">
      We found {conflicts.length} {conflicts.length === 1 ? "person" : "people"}{" "}
      in {englishifyList(Array.from(conflictingMatrices))}
    </InfoBanner>
  );
}
